export default __webpack_public_path__ + "static/media/tru-placeholder.1ac5f211.png";